import {
	config
} from '@/config';
import {
	cssConfig
} from '@/config/css';

export const mixinsData = {
	showMyLoading: true,
	...cssConfig
}
